import { EssHeader } from '@/components/ess/EssHeader';
import { FC } from 'react';
import { FiCalendar } from 'react-icons/fi';
import { NavPage } from '../../../components/page/Breadcrumbs';
import strings from '../ess.translations';

export const MyCalendarHeader: FC = () => {
  const breadcrumbs: NavPage[] = [
    {
      name: strings.myCalendar.header,
      to: `/ess/my-calendar`
    }
  ];

  return <EssHeader title={strings.myCalendar.header} icon={FiCalendar} breadcrumbs={breadcrumbs} />;
};
